import styled, { css } from 'styled-components';
import { mediaMixin, token } from '@zillow/constellation';

export const Container = styled.div`
  width: 100%;
  padding: 0px 24px 8px 64px;

  ${mediaMixin(
    'md',
    css`
      padding: 0 12px 20px 72px;
    `,
  )};
`;

export const Dot = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: ${token('colors.forRent')};
  float: left;
  margin-top: 3px;
  margin-right: 8px;
`;
